import { render, staticRenderFns } from "./MessageMoveToFolderModal.vue?vue&type=template&id=76f75db5&scoped=true&"
import script from "./MessageMoveToFolderModal.vue?vue&type=script&lang=js&"
export * from "./MessageMoveToFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageMoveToFolderModal.vue?vue&type=style&index=0&id=76f75db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f75db5",
  null
  
)

export default component.exports